export default {
  LIST: 'listOfSku',
  NOSTO: 'nosto',
  UPSELLS: 'upsells (PDP only)',
  CATEGORY: 'category'
};
